<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List Kontak
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn d-flex align-items-start" style="gap: 10px; flex-wrap: wrap;">
                            <!-- Tombol Tambah Kontak -->
                            <a @click="toggleModal('new_contact')" class="btn btn-primary text-white">
                                <i class="fas fa-plus fs-16"></i> Tambah Kontak
                            </a>

                            <a @click="toggleModal('new_wg_group')" class="btn btn-info text-white">
                                <i class="fas fa-plus fs-16"></i> Tambah Group WhatsApp
                            </a>

                            <!-- Tombol Aksi Kontak dengan Dropdown -->
                            <div style="position: relative;" ref="actionMenu">
                                <button class="btn btn-dark btn-sm dropdown-toggle"
                                    @click="dropdownOpen = !dropdownOpen">
                                    <i class="fas fa-cogs"></i> Aksi Kontak
                                </button>

                                <div class="dropdown-menu" v-show="dropdownOpen" style="
                                    text-align: left !important;
                                    display: block;
                                    position: absolute;
                                    top: 100%;
                                    left: 0;
                                    z-index: 1000;
                                    min-width: 220px;
                                    padding: 0.5rem 0;
                                    border: 1px solid rgba(0,0,0,.15);
                                    border-radius: .25rem;
                                    background-color: white;
                                    box-shadow: 0 0.5rem 1rem rgba(0,0,0,.175);
                                    transition: all 0.3s ease !important;
                                ">
                                    <a class="dropdown-item text-danger" href="#" @click="emptyContact();dropdownOpen = false">
                                        <i class="fas fa-trash"></i>&nbsp;Kosongkan Kontak
                                    </a>
                                    <a class="dropdown-item text-success" href="#"
                                        @click="toggleModal('import_contact');dropdownOpen = false">
                                        <i class="fas fa-upload"></i>&nbsp;Import Kontak
                                    </a>
                                    <a class="dropdown-item text-secondary" href="#" @click="exportContact();dropdownOpen = false">
                                        <i class="fas fa-download"></i>&nbsp;Export Kontak
                                    </a>
                                    <a class="dropdown-item text-info" href="#" @click="repairContact();dropdownOpen = false">
                                        <i class="fas fa-tools"></i>&nbsp;Repair Kontak (Dari Migrasi V2)
                                    </a>
                                    <div v-if="advance_contact == 1">
                                        <div class="dropdown-header">
                                            <h6 class="dropdown-title">Advance Contact</h6>
                                        </div>
                                        <a class="dropdown-item text-primary" href="#" @click="toggleModal('validasi_whatsapp');dropdownOpen = false">
                                            <i class="fas fa-check"></i>&nbsp;Validasi Whatsapp
                                        </a>
                                        <a class="dropdown-item text-danger" href="#" @click="toggleModal('hapus_invalid');dropdownOpen = false">
                                            <i class="fas fa-trash"></i>&nbsp;Hapus Nomor Invalid
                                        </a>
                                        <a class="dropdown-item text-warning" href="#" @click="toggleModal('hapus_duplikat');dropdownOpen = false">
                                            <i class="fas fa-trash"></i>&nbsp;Hapus Duplikat
                                        </a>
                                    </div>

                                </div>
                            </div>
                            <!-- Modal -->
                            <div class="modal fade new-member" id="import" role="dialog"
                                aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div class="modal-dialog">
                                    <div class="modal-content radius-xl">
                                        <div class="modal-header">
                                            <h6 class="modal-title fw-500" id="staticBackdropLabel">
                                                Import Kontak
                                            </h6>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span data-feather="x"></span>
                                            </button>
                                        </div>
                                        <div class="modal-body">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <ContactTable />
                    </div>
                </div>
            </div>
            <modal name="new_contact" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddContact :groupdd='group_dropdown' />
                </div>
            </modal>
            <modal name="import_contact" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <ImportContact :groupdd='group_dropdown' />
                </div>
            </modal>
            <modal name="validasi_whatsapp" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <ValidasiWhatsapp />
                </div>
            </modal>
            <modal name="hapus_duplikat" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <HapusDuplikat />
                </div>
            </modal>
            <modal name="hapus_invalid" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <HapusInvalid />
                </div>
            </modal>
            <modal name="new_wg_group" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddWgGroup :groupdd='group_dropdown' />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import ContactTable from "@/components/tables/Contact.vue";
    import AddContact from "@/components/forms/contact/Add.vue";
    import ImportContact from "@/components/forms/contact/Import.vue";
    import ValidasiWhatsapp from "@/components/forms/contact/ValidasiWhatsapp.vue";
    import HapusDuplikat from "@/components/forms/contact/HapusDuplikat.vue";
    import HapusInvalid from "@/components/forms/contact/HapusInvalid.vue";
    import AddWgGroup from "@/components/forms/wg-group/Add.vue";
    import Papa from 'papaparse' // pastikan ini sudah di-install via npm

    export default {
        components: {
            ContactTable,
            AddContact,
            ImportContact,
            ValidasiWhatsapp,
            HapusDuplikat,
            HapusInvalid,
            AddWgGroup
        },
        data() {
            return {
                group_dropdown: [],
                exportJson: [],
                dropdownOpen: false,
                advance_contact: 0
            };
        },
        beforeDestroy() {
            this.$root.$off("toggle_modal", this.fnToggleModal);
            document.removeEventListener('click', this.handleClickOutside);
        },
        mounted() {
            this.advance_contact = this.$store.state.auth.package.advance_contact ?? 0

            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
            document.addEventListener('click', this.handleClickOutside);
        },
        methods: {
            handleClickOutside(event) {
                if (!this.$refs.actionMenu.contains(event.target) && !this.$refs.actionMenu.contains(event.target.parentNode)) {
                    this.dropdownOpen = false;
                }
            },
            async loadGroups() {
                try {
                    let response = await this.$store.dispatch('group_list_dropdown')
                    this.group_dropdown = response.data.data.groups
                } catch (err) {
                    this.$toast.error("Server error")
                }
            },
            async emptyContact() {
                if (confirm("Semua data kontak akan terhapus, Yakin ?")) {
                    try {
                        let response = await this.$store.dispatch('contact_empty')
                        this.$toast.success(response.data.message);
                        this.$root.$emit("refresh_table", true)
                    } catch (err) {
                        this.$toast.error(err.response.data.message);
                    }
                }
            },
            async repairContact() {
                if (confirm(
                        "Data kontak akan diperbaiki, mohon backup data sebelum melakukan repair kontak. Konfirmasi ?"
                        )) {
                    try {
                        this.$toast.success("Repair kontak sedang diproses");
                        let response = await this.$store.dispatch('contact_repair')
                        this.$toast.success(response.data.message);
                        this.$root.$emit("refresh_table", true)
                    } catch (err) {
                        this.$toast.error(err.response.data.message);
                    }
                }
            },
            async exportContact() {
            try {
                this.$toast.info("Mohon Tunggu...");

                const response = await this.$store.dispatch('contact_export');
                const rawData = response.data.data.contacts;
                const final = [];

                for (let i = 0; i < rawData.length; i++) {
                const contact = rawData[i];

                // Format nomor
                if (contact.number.startsWith('0')) {
                    contact.number = '62' + contact.number.substring(1);
                }

                // Bangun baris
                const row = {
                    "Nama": contact.name,
                    "Whatsapp": contact.number,
                };

                // Parse variabel tambahan
                let vars = [];
                if (contact.data) {
                    try {
                    vars = JSON.parse(contact.data);
                    } catch (e) {
                    vars = [];
                    }
                }

                for (let j = 0; j < 5; j++) {
                    row['VARIABEL ' + (j + 1)] = vars[j]?.value ?? "";
                }

                final.push(row);
                }

                // Ubah jadi CSV string
                const csv = Papa.unparse(final);

                // Buat file download
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "starsender-contact-" + new Date().toISOString().split('T')[0] + ".csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);

                this.$toast.success("Export berhasil!");

            } catch (err) {
                this.$toast.error("Gagal mengekspor: " + err.message || err);
            }
            },
            fillVar(val) {
                return val
            },
            toggleModal(param) {
                if (this.group_dropdown.length == 0) this.loadGroups()

                this.$modal.toggle(param);
            },
        },
    };
</script>

<style scoped>
.dropdown-item {
    text-align: left !important;
    display: block !important;
}
</style>